const getSearchQueryString = (section) => {
  const currentProductId = section.querySelector('[data-current-product-id]')?.dataset.currentProductId;
  const limit = Number(section.dataset.productsToShow) || 4;
  let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

  if (currentProductId) {
    items = items.filter((item) => String(item) !== String(currentProductId));
  }

  return items
    .slice(0, limit)
    .map((item) => `id:${item}`)
    .join(' OR ');
};

const initRecentlyViewedCarousel = (section) => {
  const flickityElement = section.querySelector('.slider-flickity');
  if (!flickityElement || typeof Flickity === 'undefined') return;

  const flkty = new Flickity(flickityElement, {
    cellAlign: 'left',
    freeScroll: true,
    pageDots: false,
    groupCells: true,
    contain: true,
  });
  flkty.resize();
};

const recentlyViewed = async (section) => {
  const queryString = getSearchQueryString(section);
  if (!queryString) return;

  try {
    const url = `${window.routes.search_url}?view=recently-viewed-products&type=product&q=${encodeURIComponent(queryString)}`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
    });

    if (!response.ok) return;

    const content = await response.text();
    const tempElement = document.createElement('div');
    tempElement.innerHTML = content;

    const countEl = tempElement.querySelector('.products_count[data-count]');
    const productCount = Number(countEl?.dataset.count || 0);
    if (productCount === 0) return;

    const placeholder = section.querySelector('.recently-viewed-products-placeholder');
    const partial = tempElement.querySelector('.recently-viewed-products-placeholder');
    if (!placeholder || !partial) return;

    placeholder.innerHTML = partial.innerHTML;
    section.style.display = 'block';
    initRecentlyViewedCarousel(section);

    if (typeof generateSwatches === 'function') {
      section.querySelectorAll('card-colours').forEach(generateSwatches);
    }

    document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
  } catch (error) {
    console.error('Error fetching recently viewed products:', error);
  }
};

const bootRecentlyViewed = () => {
  const section = document.querySelector('section-recentlyviewed');
  if (!section) return;

  const run = () => recentlyViewed(section);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 3000 });
  } else {
    setTimeout(run, 1);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootRecentlyViewed);
} else {
  bootRecentlyViewed();
}
